// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__742LJ","signatureBlock":"Footer_signatureBlock__3FTFp","signature":"Footer_signature__VUhBH"};